import React, { Component } from 'react'

import Scroll from 'react-scroll'
import { translate } from 'react-translate'


import ActionBar from '../../../containers/Sections/Propiedades/actionBar'
import GalleryList from '../../../containers/Sections/Propiedades/List/gallery'
import MapList from '../../../containers/Sections/Propiedades/List/map'
import List from '../../../containers/Sections/Propiedades/List/list'
import PaginationButtons from '../../../containers/Sections/Propiedades/pagination'
import Button from '../../Buttons'
import Spinner from '../../Spinner'

@translate('Propiedades')
class Propiedades extends Component {

  // eslint-disable-next-line react/no-deprecated
  componentWillMount(){
    window.scrollTo(0, 0)
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps() {
    if(this.props.urlLocation.query && this.props.urlLocation.query.q) {
      this.props.updateUrl(this.props.urlLocation.query.q)
    }
  }

  componentDidMount() {
    this.props.setHeaderDetails()
    this.props.searchPropiedades()
  }

  componentWillUnmount(){
    this.props.setHeaderDetails()
    this.props.changeSearchOrigin()
  }

  render () {
    const {
      listType,
      properties,
      onClickViewMap,
      onClickViewGallery,
      loading,
			t
    } = this.props

    let page_class = loading ? 'hidden' : ''

    if (properties.length > 0 || loading) {
      var list = ''

      var pagination = (
        <div className={page_class}>
          <PaginationButtons />
        </div>
      )

      if (listType == 'list') list = <List />
        else if (listType == 'map') {
          list = <MapList />
          pagination = ( <div className={page_class}> <PaginationButtons /> </div>)
        }
        else list = <GalleryList />

      let content
      if (loading) {
        content = (
          <Spinner />
        )
      }
      else {
        content = list
      }

      var Element = Scroll.Element
      return (
        <Element name='ContainerPropiedades'>
          <div className='propiedades-content clearfix'>
            <div className='col-md-12'>
              <ActionBar />
              {content}
              {pagination}
            </div>
            <div className='buttons-mobile col-xs-12 visible-xs'>
              <div className={'col-xs-6 view-option' + (listType == 'gallery' ? ' active-btn' : '') }>
                <Button type='submit' clickButton={onClickViewGallery}>
                  <i className='fa fa-bars'></i>
                  <p>{t('Ver_Lista')}</p>
                </Button>
              </div>
              <div className={'col-xs-6 view-option' + (listType == 'map' ? ' active-btn' : '') }>
                <Button type='submit' clickButton={onClickViewMap}>
                  <i className='fa fa-map-marker'></i>
                  <p>{t('Ver_Mapa')}</p>
                </Button>
              </div>
            </div>
          </div>
        </Element>
      )
    }
    else{
      return(
        <div className='propiedades-content clearfix'>
          <div className='col-md-12 col-error'>
            <div className='no-properties-box'>
              <i className='fa fa-exclamation-circle' aria-hidden='true'></i>
              <p>{t('No_Propiedades')}</p>
            </div>
          </div>
        </div>
      )
    }
  }
}

export default Propiedades



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/index.js